import Loadable from '../../components/loadable';

const EditIncomeCategory = Loadable({
  loader: () => import('../../pages/account_profile/edit_income_category'),
});

angular.module('gym').value('EditIncomeCategory', EditIncomeCategory);
